import type { Nullable } from '../typescript/nullable';

export enum NodeCleanupTypeEnum {
	DUPLICATE_FILES = 'DUPLICATE_FILES',
	SIMILAR_FILES = 'SIMILAR_FILES',
	SIMILAR_TAGS = 'SIMILAR_TAGS',
	NOISE_TAGS = 'NOISE_TAGS',
	LEAF_TAGS = 'LEAF_TAGS',
}

export interface NodeCleanupInterface {
	id: string;
	type: NodeCleanupTypeEnum;
	createdAt: Date;
	nodeIds: string[];
	primaryId: Nullable<string>;
}

export type CreateNodeCleanup = Omit<NodeCleanupInterface, 'id' | 'createdAt'>;

export type UpdateNodeCleanup = Partial<Pick<NodeCleanupInterface, 'primaryId' | 'nodeIds'>>;

export const DEFAULT_NODE_CLEANUP_PAGE_SIZE = 4;
